module.exports = __webpack_public_path__ + "img/work_from_office1.4cbe5424.png";